import React, { useContext, useEffect, useRef, useState } from "react";
import { Dropdown, Modal, Space } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import userImg from '../../assets/newImages/User.svg';
import usePartnerName from "../../hooks/usePartnerName";
import { setPartnerData, setUserProfile } from "../../Reducer/globalSlice";
import { handleErrorMessage } from "../../utils/helper";
import { GlobalContext } from "../globalContext/GlobalContext";
import { AddOrganization, AddOrganizationActive, Back, Menu, Share, User } from "../Icons/Icons";
import { resetLocalStorage, setPartnerLatitude, setPartnerLongitude } from "../../Reducer/localStorageSlice";
import ToastComponent from "../ToastCompoent/ToastComponent";
import './navbar.scss';
import { persistor } from "../../Reducer/store";
import { navBarRouterPathURl } from "../../utils/constants";
import { PlusOutlined } from '@ant-design/icons';
import home from "../../assets/newImages/Home.svg"

const environment = process.env.ENV || ''
const navBarLinks = [
  { displayName: 'Home', link: `${environment === 'PRODUCTION' ? '/' : navBarRouterPathURl}`, type: 'link' },
  // { displayName: 'Browse', link: '/microsite', type: 'link' },
  {
    displayName: (
      <>
        <PlusOutlined /> Apply Now
      </>
    ),
    link: '/onboarding',
    classNames: 'onboarding',
    type: 'link',
  },

  // share icon in nav finds and clicks on share icon in footer
  { icon: <Share />, type: 'icon', className: 'cursor-pointer', ariaLabel: "share site", onClick: () => { document.getElementById('footer-share-icon').click() } }
]

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileImageRef = useRef(null);
  const profileOptionsRef = useRef(null);
  const routerLocation = useLocation();
  const { formattedName: partner } = usePartnerName()
  const { globalState, setGlobalState, profileUpdated, setProfileUpdated } = useContext(GlobalContext);

  const [showProfileOptions, setShowProfileOptions] = useState(false);

  const isEditPage = routerLocation?.pathname?.includes("/edit");
  const isOnboardingPage = routerLocation?.pathname?.includes("/onboarding");


  const reduxGlobalState = useSelector(state => state.global)
  const partnerData = useSelector(state => state.global.partner)
  const localData = useSelector((state) => state?.localStorage)

  const { accessToken } = localData


  const handleClickOutside = (event) => {
    if (
      profileOptionsRef.current &&
      !profileOptionsRef.current.contains(event.target) &&
      profileImageRef.current &&
      !profileImageRef.current.contains(event.target)
    ) {
      setShowProfileOptions(false);
    }
  };

  const toggleProfileOptions = () => {
    setShowProfileOptions(prev => !prev);
  };

  const handleEditNavigation = () => {
    setShowProfileOptions(false);
    navigate("/edit")
  }

  const getPartnerDetails = async (partner) => {
    try {
      const response = await getRequest(
        userapiservice.getPartnerDetails(partner)
      );
      if (response) {
        dispatch(setPartnerLatitude(response?.latitude))
        dispatch(setPartnerLongitude(response?.longitude))
        dispatch(setPartnerData(response))
        // set partnerId in global context also
        setGlobalState({
          ...globalState,
          "partnerID": response.id,
          "partnerName": response.name
        })
      }
    } catch (error) {
      Modal.error({
        title: "Error",
        content: error.response?.data?.message || "Something went wrong...",
      });
      toast.error(<ToastComponent type={'Error'} message={handleErrorMessage(error, "Failed to fetch Partner details")} />)

    }
  };

  // popover items when hamburger is clicked
  const hamburgerItems = navBarLinks.map((ele, i) => {
    if (ele.link !== '/onboarding')
      return {
        key: i,
        label: <NavLink to={ele.link} className={`${(routerLocation.pathname === ele.link) ? 'active text-danger' : 'text-primary'} nav-link ${ele.classNames}  `}>
          {ele.displayName}
        </NavLink>
      }
  })

  const handleLogout = () => {
    navigate("/")
    // set localstorageSlice to initial state
    dispatch(resetLocalStorage())
    // ser userProfile to null
    dispatch(setUserProfile(null))

    // Clears persisted state
    persistor?.purge();
    persistor?.flush();

    localStorage.removeItem("persist:root");
    localStorage.clear();

    // redirect to / and reload
    window.location.href = '/';
    window.location.reload();
    navigate("/")
  };

  const getUserDetails = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,

      };
      const response = await getRequest(
        userapiservice.getEndUserDetails(),
        headers,
        false
      );

      if (response) {
        dispatch(setUserProfile(response))
        setProfileUpdated(false);
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={handleErrorMessage(error, "Failed to fetch profile details")} />)
    }
  }

  useEffect(() => {
    if ((!reduxGlobalState.userProfile || profileUpdated === true) && accessToken) {
      // get user details 
      getUserDetails()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileUpdated, reduxGlobalState.userProfile, dispatch])






  useEffect(() => {
    if (partner && !reduxGlobalState.partner) {
      getPartnerDetails(partner);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const location = useLocation();
  const handleBack = () => {
    // If we are currently on /onboarding and the previous page was /term → skip it
    const prevPath = document.referrer; // gives you the previous URL

    if (location.pathname === "/onboarding" && prevPath.includes("/term")) {
      // 🚀 Instead of going back to /term, go back 2 steps if possible
      if (window.history.state && window.history.state.idx > 1) {
        navigate(-2);
      } else {
        // fallback if no history
        navigate("/");
      }
    } else if (window.history.state && window.history.state.idx > 0) {
      navigate(-1); // normal back
    } else {
      navigate("/"); // fallback home (or onboarding if you prefer)
    }
  };

  window.onload = function () {
    sessionStorage.clear();
  };

  const HideHomePage = () => {
    if(routerLocation.pathname?.replace('_','').toLowerCase() === navBarRouterPathURl?.replace("_",'')?.toLowerCase() || routerLocation.pathname === "/" ) {
      return true;
    }
    return false;
  }

  if (globalState.isMobile) {
    return (
      <nav className="navbar navbar-mobile justify-content-between align-content-center">
        {routerLocation.pathname?.replace("_", "").toLowerCase() ===
          navBarRouterPathURl?.replace("_", "")?.toLowerCase() ||
        routerLocation.pathname === "/" ? (
          <span className="nav-partner-menu">
            {/* <Dropdown menu={{ items: hamburgerItems }} trigger={['click']}>
          <Space onClick={(e) => e.preventDefault()}>
            <Menu />
          </Space>
        </Dropdown> */}
          </span>
        ) : (
          <span className="nav-partner-menu" onClick={handleBack}>
            <Back />
          </span>
        )}

        <span className="nav-partner-logo nav-partner-with-logo">
          {partnerData?.mediaLink && (
            <img src={partnerData?.mediaLink} alt="partner logo" />
          )}
        </span>

        <ul className="navbar-nav d-flex justify-content-between  align-items-center flex-row p-0 m-0 h-100">
          {
            <li className={`nav-item fw-bold`}>
              <NavLink to={"/onboarding"} className={` nav-link `}>
                {routerLocation.pathname !== "/onboarding" && (
                  <AddOrganization />
                )}
              </NavLink>
            </li>
          }

          <li className="nav-item fw-bold">
            {reduxGlobalState?.userProfile?.phoneNumber || accessToken ? (
              <div>
                <img
                  className="user-icon"
                  src={reduxGlobalState?.userProfile?.mediaLink || userImg}
                  alt="user-icon"
                  style={{ cursor: "pointer" }}
                  onClick={toggleProfileOptions}
                />
              </div>
            ) : (
              <NavLink
                to={"/login"}
                className={`${
                  routerLocation.pathname === "/login"
                    ? "active text-danger"
                    : "text-primary"
                } nav-link`}
              >
                <User />
              </NavLink>
            )}
          </li>
        </ul>
        {showProfileOptions && (
          <div className="profile-options" ref={profileOptionsRef}>
            {!isEditPage && (
              <div className="profile-option" onClick={handleEditNavigation}>
                Edit Profile
              </div>
            )}
            <div className="profile-option" onClick={handleLogout}>
              Logout
            </div>
          </div>
        )}
      </nav>
    );
  }

  return (
    <nav className="navbar navbar-desktop row justify-content-between align-content-center m-0 navbar-expand-lg">
      <div className="headerMain">
        <div className="headerRow">
          {/* Left Column - Logo */}
          <div className="headerCol headerLeft">
            <div className="headerLogo">
              {partnerData?.mediaLink && (
                <img
                  src={partnerData?.mediaLink}
                  className="img-fluid"
                  alt="Partner Logo"
                />
              )}
            </div>
          </div>

          {/* Center Column - Site Name */}
          <div className="headerCol headerCenter">
            <div className="headerSiteName">
              <h3>{partnerData?.siteName}</h3>
            </div>
          </div>

          {/* Right Column - Menu/Profile */}
          <div className="headerRight">
            <div className="headerMenu">
              <ul>
                {navBarLinks.map((ele, i) => (
                  <React.Fragment key={i}>
                    {ele.displayName === "Home" &&
                    HideHomePage() ? null : ele?.classNames === "onboarding" &&
                      isOnboardingPage ? null : (
                      <li className="nav-item fw-bold">
                        {ele.type === "link" ? (
                          <NavLink
                            to={ele.link}
                            className={`${
                              routerLocation.pathname === ele.link
                                ? "active text-danger"
                                : "text-primary"
                            } nav-link ${ele.classNames}`}
                            onClick={() => {
                              if (ele.link === "/onboarding") {
                                sessionStorage.clear();
                              }
                            }}
                          >
                            {ele.displayName === "Home" && HideHomePage()
                              ? null
                              : ele.displayName === "Home" ? <img
                            src={
                              home
                            }
                            alt="user-icon"
                            style={{ cursor: "pointer" }}
                          /> : ele.displayName  }
                          </NavLink>
                        ) : (
                          ele.type === "icon" && (
                            <button
                              className="btn btn-sm border-0"
                              aria-label={ele.ariaLabel}
                              onClick={ele.onClick}
                            >
                              {ele.icon}
                            </button>
                          )
                        )}
                      </li>
                    )}
                  </React.Fragment>
                ))}

                {/* Profile Options */}
                {showProfileOptions && (
                  <div className="profile-options" ref={profileOptionsRef}>
                    {!isEditPage && (
                      <div
                        className="profile-option"
                        onClick={handleEditNavigation}
                      >
                        Edit Profile
                      </div>
                    )}
                    <div className="profile-option" onClick={handleLogout}>
                      Logout
                    </div>
                  </div>
                )}

                {/* User / Login */}
                <>
                  {globalState.user ? (
                    <li className="nav-item fw-bold">
                      username
                      <img src="" alt="user profile" />
                    </li>
                  ) : (
                    <li className="nav-item fw-bold">
                      {reduxGlobalState?.userProfile ? (
                        <div>
                          <img
                            className="user-icon"
                            src={
                              reduxGlobalState?.userProfile?.mediaLink ||
                              userImg
                            }
                            alt="user-icon"
                            style={{ cursor: "pointer" }}
                            onClick={toggleProfileOptions}
                            ref={profileImageRef}
                          />
                        </div>
                      ) : (
                        <NavLink
                          to="/login"
                          className={`${
                            routerLocation.pathname === "/login"
                              ? "active text-danger"
                              : "text-primary"
                          } nav-link`}
                        >
                          Login
                        </NavLink>
                      )}
                    </li>
                  )}
                </>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="col-3 col-md-4 col-lg-5 d-flex align-items-center flex-row partner-info">
        <span className="navbar-brand partner-with-logo">
          {partnerData?.mediaLink && < img src={partnerData?.mediaLink} width="60" className="img-fluid" alt="" />}
        </span >
        <div class="logo-holder logo-4">
          <a href="">
            <h3>{partnerData?.siteName}</h3>
            
          </a>
        </div>
      </div >
      <ul className={`col-9 col-md-8 col-lg-7 navbar-nav d-flex align-items-center flex-row justify-content-around`}>
        {navBarLinks.map((ele, i) => {
          return <React.Fragment key={i}>
            <li className="nav-item fw-bold" >
              {
                (ele.type === 'link') ?
                  <NavLink to={ele.link} className={`${(routerLocation.pathname === ele.link) ? 'active text-danger' : 'text-primary'} nav-link ${ele.classNames}  `}
                    onClick={() => {
                      if (ele.link === "/onboarding") {
                        sessionStorage.clear();
                      }
                    }}
                  >
                    {ele.displayName}
                  </NavLink> :
                  (ele.type === 'icon') && <button className="btn btn-sm border-0" aria-label={ele.ariaLabel} onClick={ele.onClick}>{ele.icon}</button>
              }
            </li>
            <li style={{
              borderRight: '2px solid #BAC4D2', display: 'inline-block',
              width: '2px', height: '10px'
            }} >  &nbsp;</li>
          </React.Fragment>
        })}

        {showProfileOptions && (
          <div className="profile-options" ref={profileOptionsRef}>
            {!isEditPage &&
              <div className="profile-option" onClick={handleEditNavigation}>Edit Profile</div>
            }
            <div className="profile-option" onClick={handleLogout}>Logout</div>
          </div>
        )}

        <>
          {globalState.user ?
            (<li className="nav-item fw-bold">
              username
              <img src="" alt="user profile" />

            </li>)
            :
            <li className={`nav-item fw-bold`}>
              {reduxGlobalState?.userProfile ?
                <div>
                  <img className="user-icon" src={reduxGlobalState?.userProfile?.mediaLink || userImg} alt="user-icon" style={{ cursor: "pointer" }}
                    onClick={toggleProfileOptions} ref={profileImageRef}
                  />
                </div>
                :
                <NavLink to={'/login'} className={`${routerLocation.pathname === '/login' ? 'active text-danger' : 'text-primary'} nav-link`}>
                  Login
                </NavLink>
              }
            </li>}

        </>
      </ul> */}
    </nav>
  );
}

export default Navbar